<template>
  <div class="index" v-cloak v-if="banner.length > 0">
    <!-- <div class="middle" :style="display"> -->
    <div class="middle bacj" v-if="spread">
    <template >
      <input class="btn" type="button" @click="gongzlink" value="关注公众号" >
      </template>
      <div class="close" ><img :src="closeUrl" /></div>
      <!-- <div class="close"  @click="toggle()"><img :src="closeUrl" /></div> -->
    </div>
     <div class="img-top" >
      <div class="header acea-row row-center-wrapper" >
        <div class="logo"><img :src="logoUrl" /></div>
        <router-link :to="'/search'" class="search acea-row row-middle">
          <span class="iconfont icon-xiazai5"></span
          ><span class="search-terms">请输入搜索的手机型号</span>
        </router-link>
        <input class="btn" type="button" value="搜索" >
      </div>
    </div>


    <div class="container" >
      <!--<div class="swiper-container swiper1">-->
        <!--<div class="swiper-wrapper">-->
          <!--<div style="width: 50px;" class="swiper-slide selected">首页</div>-->
          <!--<div v-for="(item, index) in guige" :key="index" >-->
            <!--<router-link style="width: 50px;" class="swiper-slide" :to="{-->
                <!--path: '/goods_list',-->
                <!--query: { gid: item.id }-->
              <!--}"-->
               <!--&gt;{{ item.name }}</router-link>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->

      <div class="swiper-container swiper1">
        <swiper class="swiper-wrapper" :options="swiperProducts">
          <swiper-slide style="width: 15%"
                  class="swiper-slide"
                  v-for="(itemSeckill, indexSeckill) in guige"
                  :key="indexSeckill"
          >
            <!-- <div style="width: 50px;" class="swiper-slide selected" v-if="indexSeckill == 0">首页</div> -->
            
              <router-link style="width: 50px;" class="swiper-slide" :to="{
                path: '/goods_list',
                query: { gg: itemSeckill.id }
              }"
              >{{ itemSeckill.name }}</router-link>
            
          </swiper-slide>
        </swiper>
      </div>
    </div>


    <div style="width:95%;margin:auto;" class="slider-banner banner">
      <swiper :options="swiperOption" v-if="banner.length > 0">
        <swiper-slide v-for="(item, index) in banner" :key="index">
          <router-link
            :to="item.wap_url ? item.wap_url : ''"
            class="search acea-row row-middle"
          >
            <img :src="item.pic" />
          </router-link>
        </swiper-slide>
        <div class="swiper-pagination paginationBanner" slot="pagination"></div>
      </swiper>
    </div>
    <div class="news acea-row row-between-wrapper" v-if="banner.length > 0">
      <div class="pictrue"><img src="@assets/images/new2.png" /></div>
      <div class="swiper-no-swiping new-banner">
        <swiper
          class="swiper-wrapper"
          :options="swiperRoll"
          v-if="roll.length > 0"
        >
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in roll"
            :key="index"
          >
            <router-link
              :to="item.wap_url ? item.wap_url : ''"
              class="acea-row row-between-wrapper"
            >
              <div class="text acea-row row-between-wrapper">
                <div class="label" v-if="item.show === '是'">最新</div>
                <div class="newsTitle line1">{{ item.info }}</div>
              </div>
              <div class="iconfont icon-xiangyou"></div>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="nav acea-row">
      <router-link
        :to="item.wap_url ? item.wap_url : ''"
        class="item"
        v-for="(item, index) in menus"
        :key="index"
      >
        <div class="pictrue"><img :src="item.pic" /></div>
        <div>{{ item.name }}</div>
      </router-link>
    </div>
    <!-- <div
      class="specialArea acea-row row-between-wrapper"
      v-if="activityOne.wap_link !== undefined || activity.length"
    >
      <router-link
        :to="activityOne.wap_link ? activityOne.wap_link : ''"
        v-if="activityOne.wap_link !== undefined"
        class="assemble"
      >
        <img :src="activityOne.pic" />
        <div class="text">
          <div class="name">{{ activityOne.title }}</div>
          <div class="infor">{{ activityOne.info }}</div>
        </div>
      </router-link>
      <div class="list acea-row row-column-between">
        <router-link
          :to="item.wap_link ? item.wap_link : ''"
          class="item"
          v-for="(item, index) in activity"
          :key="index"
        >
          <img :src="item.pic" />
          <div class="text">
            <div class="name">{{ item.title }}</div>
            <div class="infor">{{ item.info }}</div>
          </div>
        </router-link>
      </div>
    </div> -->
     <div class="wrapper" v-if="info.fastList.length > 0">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">快速选择</div>
          <div class="line1">{{ info.fastInfo }}</div>
        </div>
        <router-link :to="'/category'" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div class="scroll-product">
        <swiper class="swiper-wrapper" :options="swiperScroll">
          <swiper-slide
            v-for="(item, index) in info.fastList"
            :key="index"
            class="swiper-slide"
          >
            <router-link
              :to="{
                path: '/goods_list',
                query: { id: item.id, title: item.cate_name }
              }"
            >
              <div class="img-box">
                <img :src="item.pic" />
              </div>
              <div class="pro-info line1">{{ item.cate_name }}</div>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    
    <div class="wrapper" v-if="info.firstList.length > 0">
      <div class="title acea-row row-between-wrapper">
        <router-link :to="{ path: '/activity/goods_seckill' }" >
        <div class="text">
          <div class="clock"><img :src="clockUrl" /></div>
          <div class="kill"><img :src="killUrl" /></div>
        </div>
        </router-link>
        <!-- <router-link :to="{ path: '/activity/goods_seckill' }" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>  -->
        <div class="countDown font-color-red acea-row row-center-wrapper">
          <CountDown
            :is-day="false"
            :tip-text="''"
            :day-text="''"
            :hour-text="' 时 '"
            :minute-text="' 分 '"
            :second-text="'秒'"
            :datatime="datatime"
          ></CountDown>
        </div>

      </div>
      <div class="newProducts">
        <swiper class="swiper-wrapper" :options="swiperProducts">
          <swiper-slide
            class="swiper-slide"
            v-for="(itemSeckill, indexSeckill) in seckillList"
            :key="indexSeckill"
          >
            <div
              v-if="itemSeckill.stock > 0"
              @click="goDetail(itemSeckill.id,itemSeckill.product_id)"
            >
              <div class="img-box">
                <img :src="itemSeckill.image" />
              </div>
              <div class="pro-info line1" v-text="itemSeckill.title"></div>
              <div class="money font-color-red">￥{{ itemSeckill.price }}</div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    
        <div
      class="wrapper"
      v-if="info.bastList.length > 0 || info.bastBanner.length > 0"
     >
      <!-- <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">精品推荐</div>
          <div class="line1">{{ info.bastInfo }}</div>
        </div>
      </div> -->
      
       <!-- <div class="slider-banner boutique">
        <swiper class="swiper-wrapper" :options="swiperBoutique">
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in info.bastBanner"
            :key="index"
          >
            <router-link :to="item.wap_link ? item.wap_link : ''"
              ><img :src="item.img"
            /></router-link>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination paginationBoutique"></div>
      </div> -->
      <!-- <Good-list :good-list="info.bastList" :is-sort="false"></Good-list> -->
      
      <IndexGoodlist />
    </div>
    
    <!-- <div class="hotList" v-if="likeInfo.length > 0">
      <div class="hot-bg">
        <div class="title acea-row row-between-wrapper">
          <div class="text line1">
            <span class="label">热门榜单</span>根据销量、搜索、好评等综合得出
          </div>
          <router-link :to="{ path: '/hot_new_goods/' + 2 }" class="more">
            更多<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
      </div>
      <div class="list acea-row row-middle">
        <router-link
          :to="{ path: '/detail/' + item.id }"
          class="item"
          v-for="(item, index) in likeInfo"
          :key="index"
        >
          <div class="pictrue">
            <img :src="item.image" />
            <img
              src="@assets/images/one.png"
              class="numPic"
              v-if="index === 0"
            />
            <img
              src="@assets/images/two.png"
              class="numPic"
              v-else-if="index === 1"
            />
            <img
              src="@assets/images/three.png"
              class="numPic"
              v-else-if="index === 2"
            />
          </div>
          <div class="name line1">{{ item.store_name }}</div>
          <div class="money font-color-red">
            ￥<span class="num">{{ item.price }}</span>
          </div>
        </router-link>
      </div>
    </div> -->
    <!-- <div v-if="lovely.img">
      <div class="adver">
        <img :src="lovely.img" />
      </div>
    </div>
    <div class="wrapper" v-if="benefit.length > 0">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">促销单品</div>
          <div class="line1">{{ info.salesInfo }}</div>
        </div>
        <router-link :to="'/promotion'" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
    </div>
    <Promotion-good :benefit="benefit"></Promotion-good>
    <Coupon-window
      :coupon-list="couponList"
      v-if="showCoupon"
      @checked="couponClose"
      @close="couponClose"
    ></Coupon-window> -->
    <div style="height:1.2rem;"></div>
  </div>
 
</template>

 
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import IndexGoodlist from "@components/IndexGoodlist";
import GoodList from "@components/GoodList";
import PromotionGood from "@components/PromotionGood";
import CouponWindow from "@components/CouponWindow";
import { getHomeData, getShare } from "@api/public";
import cookie from "@utils/store/cookie";
import { openShareAll } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import {getLevel} from "@api/store";
import { getSeckillConfig, getSeckillList } from "@api/activity"; // 秒杀
import CountDown from "@components/CountDown";
import { Tab, Tabs } from "vant";
import Loading from "@components/Loading"; // 秒杀
import { getUser } from "@api/user";

const HAS_COUPON_WINDOW = "has_coupon_window";


export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide,
    IndexGoodlist,
    GoodList,
    PromotionGood,
    CouponWindow,
    CountDown, // 秒杀
    Tab,
    Tabs,
    Loading // 秒杀
  },
  props: {},
  data: function() {
    return {
      userData:[],
      spread:"",
      userInfo: {},
      showCoupon: false,
      userUrl:"https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTIIG5wQkzILdg1Peo84IUwhKh8OSjvAViaictncUkIBG5CZGVfEXh9D7XCWiagokGiaFtc31BVgzOlJaA/132",
      display: "",
      logoUrl: "",
      // closeUrl: "http://tieyige.fsrcwl.cn/images/10.gif",
      closeUrl: "http://tieyige.fsrcwl.cn/images/jian.png",
      killUrl: "http://tieyige.fsrcwl.cn/images/kill.png",
      clockUrl: "http://tieyige.fsrcwl.cn/images/nz.png",
      banner: [],
      guige: [],
      menus: [],
      roll: [],
      activity: [],
      invite: "",
      activityOne: {},
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: []
      },
      likeInfo: [],
      lovely: [],
      benefit: [],
      couponList: [],
      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      swiperBoutique: {
        pagination: {
          el: ".paginationBoutique",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      headerImg: "", //秒杀
      timeList: [],
      sticky: false,
      loading: false,
      datatime: 0,
      active: 0,
      seckillList: [],
      status: false, //砍价列表是否获取完成 false 未完成 true 完成
      loadingList: false, //当前接口是否请求完成 false 完成 true 未完成
      page: 1, //页码
      limit: 5 //数量 //秒杀
    };
  },

  mounted: function() {

    let that = this;

     that.getUrl();
         // console.log(spread);
        // console.log("======");
        //   console.log(window.location.href);
        
    
    getUser().then(res => {
        that.userData=res.data;
    });


  
    getHomeData().then(res => {
      that.logoUrl = res.data.logoUrl;
      that.$set(that, "banner", res.data.banner);
      that.$set(that, "guige", res.data.guige);
      that.$set(that, "menus", res.data.menus);
      that.$set(that, "roll", res.data.roll);
      that.$set(that, "activity", res.data.activity);
      that.$set(that, "invite", "1");
      if (res.data.activity.length) {
        var activityOne = res.data.activity.shift();
        that.$set(that, "activityOne", activityOne);
      }
      that.$set(that, "info", res.data.info);
      that.$set(that, "likeInfo", res.data.likeInfo);
      that.$set(
        that,
        "lovely",
        res.data.lovely.length ? res.data.lovely[0] : {}
      );
      console.log(res);
      that.$set(that, "benefit", res.data.benefit);
      that.$set(that, "couponList", res.data.couponList);
      that.setOpenShare();
      this.showCoupon =
        !cookie.has(HAS_COUPON_WINDOW) &&
        res.data.couponList.some(coupon => coupon.is_use);
    });

    this.mountedStart(); //秒杀
  },
  methods: {
  getUrl:function(){
   var url=window.location.href;
   var spread = url.split('=')[1]; 
   this.$set(this, "spread", spread);
   console.log(spread);
    
 },
//      changeBgc(item,index){
//          console.log(item.name);
//          var that = this;
//          var itemname = item.name;
//          getLevel().then(res => {
//              console.log(res);
//              var status = res.data.status;
//              var type = res.data.type;
//
//              if (itemname == "店中店"){
//                  if (type == 1){
//                      alert("您已经是旗舰店");
//                      return false;
//                  }
//              }
//
//              if (itemname == "旗舰店"){
//                  if (type == 1){
//                      if (status == 1){
//                          that.$router.push({path: 'goods_list',query:{gid: 101}})
//                      }else {
//                          that.$router.push({ path: "/shenhe"});
//                      }
//                  }
//              }
//          });
//      },
        gongzlink(){
 
          //点击跳转至上次浏览页面
         // this.$router.go(-1)
 
          //指定跳转地址
          this.$router.replace('/Foollow')
        },
      toggle() {
      if (this.display === "display:none") {
          this.display = "";
          } else {
        this.display = "display:none";
          }
      },
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    setOpenShare: function() {
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    },

    mountedStart: function() {
      //秒杀
      var that = this;
      getSeckillConfig().then(res => {
        that.$set(that, "headerImg", res.data.lovely);
        that.$set(that, "timeList", res.data.seckillTime);
        that.$set(that, "active", res.data.seckillTimeIndex);
        that.datatime = that.timeList[that.active].stop;
        that.getSeckillList();
        that.$nextTick(function() {
          that.sticky = true;
          // that.$refs.timeList.scrollIntoView();
        });
      });
      // this.$scroll(this.$refs.container, () => {
      //   !this.loadingList && this.getSeckillList();
      // });
      // setTimeout(function() {
      //   that.loading = true;
      // }, 500);
    },
    setTime: function(index) {
      var that = this;
      that.active = index;
      that.datatime = that.timeList[that.active].stop;
      that.getSeckillList();
    },
    getSeckillList: function() {
      var that = this;
      if (that.loadingList) return;
      if (that.status) return;
      var time = that.timeList[that.active].id;
      getSeckillList(time, { page: that.page, limit: that.limit }).then(res => {
        that.status = res.data.length < that.limit;
        that.seckillList.push.apply(that.seckillList, res.data);
        that.page++;
        that.loadingList = false;
      });
    },
    goDetail: function(id,product_id) {
      var that = this;
      var time = that.timeList[that.active].stop;
      this.$router.push({
        path: "/activity/seckill_detail/" + id + "/" + time,query: {ua:product_id }
      });
    } //秒杀
  }
};
</script>

<style scoped>
.index {
  background-color: #ededed;
}
.bacj{
  background-image: url(http://tieyige.fsrcwl.cn/images/hdh.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
